<template>
	<div>
		<filter-panel labelWidth="100px" :data="groups" @search="filterChange"></filter-panel>

		<data-list
			v-loading="loading"
			:table-style="{ name: 'webclient' }"
			:data="data"
			:columns="column"
			:btnList="btnList"
			:page="page"
			@sort-change="sortChange"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
		></data-list>

		<el-drawer
			ref="drawer"
			title="关键词"
			size="50%"
			:visible.sync="drawer"
			custom-class="custom_class"
			:show-close="false"
			:with-header="false">
			<div class="close_drawer"><span @click="$refs.drawer.closeDrawer()">收起</span></div>
			<div class="info_box">
				<div class="info">
					<div class="info_tit_test">
						<span class="info_tit">关键词：{{drawerDetail.keyWordText}}</span>
						<!-- <span class="edit" @click="editKeyword(drawerDetail)">编辑</span> -->
					</div>
					<div class="info_list">
						<span>状态：{{getStatus}}</span>
						<span>匹配类型：{{drawerDetail.matchTypeDesc}}</span>
						<span>所属广告系列：{{drawerDetail.campaignName}}</span>
						<span>所属广告组：{{drawerDetail.name}}</span>
					</div>
				</div>
				<div class="info">
					<div class="info_tit">
						广告组设置
					</div>
					<div class="setting">
						<div class="set_left">
							<span class="set_lable">最高每次点击费用</span>
							<span>¥{{drawerDetail.effectiveCpcCost || '-'}}</span>
						</div>
						<div class="set_right">
							<span class="set_lable">匹配类型</span>
							<span>{{drawerDetail.matchTypeDesc}}</span>
						</div>
					</div>
          <div class="other">
            <div class="other_lable">最终到达网址</div>
						<div v-show="drawerDetail.finalUrls == undefined || drawerDetail.finalUrls.length == 0">-</div>
            <div class="setting http" v-for="(item, index) in drawerDetail.finalUrls" :key="index">
							<span @click="openUrl(item)">{{item}}</span>
						</div>
          </div>
				</div>
			</div>
		</el-drawer>
		<customColumnModal
			:visible.sync="visible"
			nameKey="customsName"
			:list="lists"
			:customChecked="customChecked"
			@getColumn="getColumn">
		</customColumnModal>
		<form-dialog
			:dialogVisible.sync="dialogVisible"
			:destroy-on-close="true"
			ref="formDialog"
			:formData="formData"
			dialogWidth="600px"
			:dialogTitle="title"
		>
			<dialogfooter slot="footer" @onclose="handleClose" @confirm="submit"></dialogfooter>
		</form-dialog>
		<form-dialog
			:dialogVisible.sync="editDialogVisible"
			ref="formEditDialog"
			:formData="editFormData"
			dialogWidth="600px"
			dialogTitle=""
		>
			<dialogfooter slot="footer" @onclose="editClose" @confirm="submitEdit"></dialogfooter>
		</form-dialog>
	</div>
</template>
<script>
import { adSeriesStatus, accountsStatus } from '@/common/dictionary.js';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import customColumnModal from '@/components/iglobalwin/formComponents/customColumn/custom-column-modal.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import googleads from '@/backend/services/googleAds/googleAds.js';
// import mixinsWatch from '@/client/mixinsWatch/mixinsWatch';
import formDialog from '@/components/webManage/formDialog.vue';
import dialogfooter from '@/components/crm/crm-dialog-footer.vue';
import { validRequired, requiredCustom } from '@/common/elementValid.js';
const list = listPageCreate({
	searchConfig: {
		api: api.googleAds.getKeywordList,
		method: 'POST',
	},
	getQuery(data,val) {
		return _.assign({}, data, {
			startDate: val.time ? val.time[0] : '',
			endDate: val.time ? val.time[1] : '',
			id: val.$route.query.adGroupId ? val.$route.query.adGroupId : '0', // 广告组id
			campaignId: val.$route.query.adSeriesId ? val.$route.query.adSeriesId : '', // 广告系列id
			status: JSON.parse(localStorage.getItem('adKeywordStatus')).status,
			adGroupStatus: JSON.parse(localStorage.getItem('adKeywordStatus')).adGroupStatus,
			keyWordStatus: JSON.parse(localStorage.getItem('adKeywordStatus')).keyWordStatus,
		});
	},
});

export default {
	props: {
		time: {
			type: Array,
			default: function () {
				return [];
			},
		}
	},
	mixins: [list],
	data() {
		return {
			column: [],
			groups: {},
			btnList: [],
			drawer: false,
			drawerDetail: {},
			visible: false,
			dialogVisible: false,
			editDialogVisible: false,
			title: '',
			formData: {},
			editFormData: {},
			lists: [],
			customChecked: [],
		};
	},

	watch: {
    time: {
      handler () {
				this.query();
      },
      // immediate: true,
			deep: true,
    },
  },

	computed: {
		getStatus() {
			// 获取状态映射值
			return accountsStatus[this.drawerDetail.status]
		},
	},

	methods: {
		filterChange(val) {
			localStorage.setItem('adKeywordStatus',JSON.stringify(val));
			this.query();
		},
		requestData() {
			this.setGroups();
		},
		setGroups() {
			let that = this;
			this.groups = {
				others: [
					{
            tagName: 'sky-select',
            placeholder: '请选择广告系列状态',
            label: '广告系列状态',
            // inputTitle: '广告系列状态',
            tagFormatStyle: true,
            // 'collapse-tags': true,
            prop: 'status',
            multiple: true,
            value: ['ENABLED', 'PAUSED'],
            options: adSeriesStatus,
          },
          {
            tagName: 'sky-select',
            placeholder: '请选择广告组状态',
            label: '广告组状态',
            // inputTitle: '广告组状态',
            tagFormatStyle: true,
            // 'collapse-tags': true,
            prop: 'adGroupStatus',
            multiple: true,
            value: ['ENABLED', 'PAUSED'],
            options: adSeriesStatus,
          },
					{
            tagName: 'sky-select',
            placeholder: '请选择关键词状态',
            label: '关键词状态',
            // inputTitle: '关键词状态',
            tagFormatStyle: true,
            // 'collapse-tags': true,
            prop: 'keyWordStatus',
            multiple: true,
            value: ['ENABLED', 'PAUSED'],
            options: adSeriesStatus,
          },
				],
			};

			this.btnList = [
				{
					name: '新建关键词',
					position: 'left',
					attribute: {
						type: 'primary',
						size: 'small',
					},
					btnClick: this.addKeyword,
				},
        {
					name: '自定义列',
					position: 'right',
					attribute: {
						// type: 'primary',
						size: 'small',
					},
					btnClick: this.getColumn,
				},
        // {
				// 	name: '导出数据',
				// 	position: 'right',
				// 	attribute: {
				// 		type: 'primary',
				// 		size: 'small',
				// 	},
				// 	btnClick: this.exportData,
				// },
			];
			this.column = [
				{
          label: '状态',
          type: 'switchBtn',
          bind: 'status',
					fixed: "left",
          activeValue: 'ENABLED',
          inactiveValue: 'PAUSED',
          toggle(val, row) {
						that.changeStatus(val,row);
          },
        },
				{
					label: '关键词',
					bind: 'keyWordText',
					fixed: "left",
					minWidth: 180,
					showOverflowTooltip: true,
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'left',
					style: 'text',
					fixed: "left",
					minWidth: 120,
					bind() {
						let arr = [
							{
								text: '详情',
								trigger: row => {
									that.openDrawer(row);
								},
							},
              // {
							// 	text: '编辑',
							// 	trigger: row => {
							// 		that.editKeyword(row);
							// 	},
							// 	showButton(row) {
							// 		return row.status !== 'REMOVED';
							// 	},
							// },
              {
								text: '移除',
								trigger: row => {
									that.remove(row);
								},
								showButton(row) {
									return row.status !== 'REMOVED';
								},
							},
						];

						return arr;
					},
				},
        {
					label: '匹配类型',
					bind: 'matchTypeDesc',
					minWidth: 120,
				},
        {
					label: '广告系列名称',
					bind: 'campaignName',
					minWidth: 120,
					showOverflowTooltip: true,
				},
        {
					label: '广告组名称',
					bind: 'name',
					minWidth: 120,
				},
        {
					label: '最终到达网址',
					bind: 'sendTime',
					minWidth: 120,
				},
        {
					label: '最高每次点击费用(￥)',
					bind: 'effectiveCpcCost',
          width: 170,
					sort: 'effectiveCpcCost',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '消耗(￥)',
					bind: 'cost',
					minWidth: 120,
					sort: 'cost',
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '展示次数',
					bind: 'impressions',
					sort: 'impressions',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '点击次数',
					bind: 'clicks',
					sort: 'clicks',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '转化次数',
					bind: 'conversions',
					sort: 'conversions',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
        {
					label: '点击率',
					bind: 'ctr',
					type: 'defaultTextUnitCustom',
					sort: 'ctr',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
					click(val) {
						return ''+val.row.ctr+'%'
					}
				},
        {
					label: '点击均价(￥)',
					bind: 'averageCpc',
          width: 120,
					sort: 'averageCpc',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
			];
		},
		// 查看详情
		openDrawer(row) {
			this.drawerDetail = row;
			this.drawer = true;
		},
		// exportData() {
		// 	console.log('导出数据')
		// },
		addKeyword() {
			this.title = '提示';
			this.dialogVisible = true;
			this.setFormData();
		},
		// 设置新建关键词弹窗数据
		setFormData() {
			this.formData = {
				adRadio: {
					label: '',
					labelWidth: '0px',
					formType: 'sky-radio',
					options: [
						{
								label: '选择已有广告系列',
								value: 1,
						},
						{
								label: '新建广告系列',
								value: 0,
						},
					],
					value: 1,
					border: true,
					prop: 'adRadio',
					rules: [validRequired('此项必填', 'change')],
				},
				adCard: {
					label: '',
					labelWidth: '0px',
					formType: 'sky-card-cascade-panel',
					value: undefined,
					isChildren: true,
					props: {
						label: 'name',
						value: 'resourceName',
						lazy: false,
					},
					// api: '',
					prop: 'adCard',
					rules: [requiredCustom('此项必填', 'change')],
					displayWith: () => {
						// 选择新建广告系列不显示
						return this.formData.adRadio.value !== 0;
					},
				},
			};
		},
		// 关闭新建关键词弹框
		handleClose() {
			this.dialogVisible = false;
			this.$nextTick(() => {
				this.$refs.formDialog.reset();
			});
		},
		submit () {
      this.$refs.formDialog.validate(async valid => {
        if (valid) {
					if(this.formData.adRadio.value == 0) {
						// 新建广告系列
						this.$router.push({
							name: 'addAdSeries',
						});
					}else {
						// 新建关键词
						this.$router.push({
							name: 'addAdKeyword',
							query: {
								adSeriesId: this.formData.adCard.value.adSeriesId,
								adSeriesName: this.formData.adCard.value.adSeriesName,
								adGroupId: this.formData.adCard.value.adGroupId,
								adGroupName: this.formData.adCard.value.adGroupName,
								resourceName: this.formData.adCard.value.resourceName,
							},
						});
					}
        }
      })
    },
		// 编辑关键词
		editKeyword(row) {
			let that = this;
			this.editDialogVisible = true;
			console.log('editFormData',this.editFormData.adRadio);
			this.editFormData = {
				adRadio: {
					label: '关键词',
					// labelWidth: '0px',
					formType: 'sky-input',
					value: row.keyWordText,
					border: true,
					prop: 'adRadio',
					rules: [validRequired('此项必填', 'change')],
				},
				type: {
          label: '匹配类型',
          value: row.matchType,
          options: [
						{
							code: 'BROAD',
							name: '广泛匹配'
						},
						{
							code: 'PHRASE',
							name: '词组匹配'
						},
						{
							code: 'EXACT',
							name: '完全匹配'
						},
					], // 关键词匹配方式
          formType: 'sky-select',
					prop: 'type',
          props: {
            label: 'name',
            value: 'code'
          },
					change(val) {
						if(val == 'BROAD' || !row.keyWordText) {
							// 广泛匹配
							that.editFormData.adRadio.value = that.editFormData.adRadio.value.replace(/\[|]|"/g,'');
							return false;
						}else if(val == 'PHRASE') {
							// 词组匹配
							that.editFormData.adRadio.value = '"'+that.editFormData.adRadio.value.replace(/\[|]|"/g,'')+'"'
						}else if(val == 'EXACT') {
							// 完全匹配
							that.editFormData.adRadio.value = '['+that.editFormData.adRadio.value.replace(/\[|]|"/g,'')+']'
						}
						console.log('that',that,'val',val)
					},
          rules: [validRequired('请选择匹配类型', 'change')]
        },
				rul: {
					label: '最终到达网址',
					placeholder: '请输入最终到达网址',
					// labelWidth: '0px',
					formType: 'sky-input',
					value: row.finalUrls[0] || '',
					border: true,
					prop: 'url',
					// rules: [validRequired('此项必填', 'change')],
				},
			};
			this.editFormData.type.change(row.matchType);
		},
		// 编辑关键词提交
		submitEdit () {
      this.$refs.formEditDialog.validate(async valid => {
				if (valid) {
					// 编辑保存关键词
					console.log(8888888,valid,this.editFormData.adRadio.value);
					this.editDialogVisible = false;
					this.drawer = false; // 成功后关闭抽屉弹框
        }
      })
    },
		// 关闭编辑关键词弹框
		editClose() {
			this.editDialogVisible = false;
			this.$nextTick(() => {
				this.$refs.formEditDialog.reset();
			});
		},
		// 跳转链接打开新窗口
    openUrl(http) {
      window.open(http, '_blank');
    },
		async changeStatus(val, row) {
      try {
        let res = await googleads.getKeywordStatus({ id: row.id,adGroupId: row.adGroupId, status: val });
        if (res.status >= 200 && res.status < 400) {
          this.$message.success('更改成功');
        }
      } catch (e) {
        window.console.error(e);
        this.$message.info('更改成功');
      }
      this.query();
    },
		// 移除状态修改
		remove(row) {
			this.$confirm('确定要移除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async() => {
				let res = await googleads.getKeywordStatus({ id: row.id, adGroupId: row.adGroupId, status: 'REMOVED' });
				if (res.status >= 200 && res.status < 400) {
					this.$message.success('移除成功');
					this.query();
				}else {
					this.$message.info('移除失败');
				}
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消移除'
				});          
			});
		},
		// 获取自定义列表数据
		async getColumn(val) {
			if(Object.prototype.toString.call(val) === '[object Array]') {
				this.visible = false;
				let arr = [];
				arr = val.map(item => {
					return {
						...item,
						type: 4
					}
				})
				await googleads.insertCustomfieldList(arr);
				// 所有列表数据
				this.getColumnLists()
			}else {
				this.visible = true;
				let res = await googleads.getCustomfieldList(4);
				// 所有列表数据
				this.lists = res.data;
			}
		},
		// 获取列表数据
		async getColumnLists() {
			// 当前用户列表自定义字段数据
			let res = await googleads.getCustomfieldUserList(4);
			this.column = this.dataConversion(res.data);
			// 所有选中自定义列表数据
			this.customChecked = res.data;
		},
		// 数据转换
		dataConversion(data) {
			let that = this, newArr = [];
			// 带排序功能列表字段
			let sortCode = ['cost','impressions','clicks','conversions','ctr','averageCpc'];
			// 单位 元
			let unitY = ['cost','averageCpc'];
			// 单位 百分比 %
			let unitPercent = ['ctr','conversionsFromInteractionsRate'];
			data.forEach(item => {
				let lab = '';
				if((unitY.indexOf(item.columnCode.split('.')[1]) != -1 || unitY.indexOf(item.columnCode.split('.')[0]) != -1)) {
					// 加上单位 元
					lab = item.columnName + ' (￥)';
				}else if((unitPercent.indexOf(item.columnCode.split('.')[1]) != -1 || unitPercent.indexOf(item.columnCode.split('.')[0]) != -1)) {
					// 加上单位 百分比 %
					lab = item.columnName + ' (%)';
				}else {
					lab = item.columnName;
				}
				let obj = {
						label: lab,
						bind: item.columnCode.split('.')[1] || item.columnCode.split('.')[0],
						// fixed: item.columnCode.split('.')[1] == 'name' ? 'left' : '',
						minWidth: 120,
						showOverflowTooltip: true,
					};
				if(item.columnCode.split('.')[1] == 'keyWordText' || item.columnCode.split('.')[0] == 'keyWordText') {
					// 当字段为关键词名称时，修改type类型，增加 操作 字段列
					newArr.push(
					{
						...obj,
						minWidth: 180,
						// type: 'linkClick',
						fixed: "left",
					},
					{
						label: '操作',
						type: 'btnClick',
						align: 'left',
						style: 'text',
						fixed: "left",
						minWidth: 120,
						bind() {
							return [
								{
									text: '详情',
									trigger: row => {
										that.openDrawer(row);
									},
								},
								// {
								// 	text: '编辑',
								// 	trigger: row => {
								// 		that.editKeyword(row);
								// 	},
								// 	showButton(row) {
								// 		return row.status !== 'REMOVED';
								// 	},
								// },
								{
									text: '移除',
									trigger: row => {
										that.remove(row);
									},
									showButton(row) {
										return row.status !== 'REMOVED';
									},
								},
							];
						},
					});
				} else if(unitPercent.indexOf(item.columnCode.split('.')[1]) != -1 || unitPercent.indexOf(item.columnCode.split('.')[0]) != -1) {
					// 当字段为百分号单位时，增加百分号
					newArr.push({
						...obj,
						type: 'defaultTextUnitCustom',
						click(val) {
							let res =item.columnCode.split('.')[1] || item.columnCode.split('.')[0];
							if(val.row[res] != undefined) {
								return val.row[res].toFixed(2)+'%';
							}else {
								return '-'
							}
						}
					})

				} else if(item.columnCode.split('.')[1] == 'finalUrls' || item.columnCode.split('.')[0] == 'finalUrls') {
					// 最终到达网址
					newArr.push(
						{
							label: lab,
							type: 'multipleParames',
							minWidth: 320,
							// showOverflowTooltip: true,
							bind: [
								{
									text: 'finalUrls', // 展示字段
									length: 1, // 展示条数
									tip: '', // 前缀
								},
							]
						},
					)
				} else if(sortCode.indexOf(item.columnCode.split('.')[1]) != -1 || sortCode.indexOf(item.columnCode.split('.')[0]) != -1) {
					// 当字段为排序列表字段，增加排序配置
					newArr.push({
						...obj,
						sort: item.googleApiField,
						options: [
							{
								label: '由低到高',
								value: 'ASC',
							},
							{
								label: '由高到低',
								value: 'DESC',
							},
						],
					})
				}else {
					// 其他普通字段直接添加
					newArr.push(obj);
				}
			});
			// 最后在列表首部增加状态字段
			newArr.unshift(
				{
          label: '状态',
          type: 'switchBtn',
          bind: 'status',
					fixed: "left",
          activeValue: 'ENABLED',
          inactiveValue: 'PAUSED',
          toggle(val, row) {
						that.changeStatus(val,row);
          },
        }
			);
			return newArr;
		},
	},
	mounted() {
		this.requestData();
		if(!JSON.parse(localStorage.getItem('adKeywordStatus'))) {
			localStorage.setItem('adKeywordStatus',JSON.stringify({status:['ENABLED','PAUSED'],adGroupStatus:['ENABLED','PAUSED'],keyWordStatus:['ENABLED','PAUSED']}));
		}
		
		this.setGroups();
		if(this.$route.path.includes('accountManagement')) {
			this.groups.others[0].value = JSON.parse(localStorage.getItem('adKeywordStatus')).status || ['ENABLED','PAUSED'];
			this.groups.others[1].value = JSON.parse(localStorage.getItem('adKeywordStatus')).adGroupStatus || ['ENABLED','PAUSED'];
			this.groups.others[2].value = JSON.parse(localStorage.getItem('adKeywordStatus')).keyWordStatus || ['ENABLED','PAUSED'];
		}
		this.getColumnLists();
		this.query();
	},
	components: { filterPanel, formDialog, dialogfooter, customColumnModal },
};
</script>
<style lang="scss">
.custom_class {
	overflow-y: auto;
	background-color: #F6F8FC;
	.el-drawer__header {
		display: none;
	}
	.close_drawer {
		line-height: 40px;
		padding-left: 20px;
		color: #3DA1FF ;
		background-color: #FFFFFF;
		&>span {
			cursor: pointer;
		}
	}
	.info_box {
		padding: 20px;
		.info {
			padding: 30px;
			margin-bottom: 10px;
			line-height: 40px;
			border-radius: 6px;
			background: #FFFFFF ;
			.info_tit_test {
				display: flex;
				justify-content: space-between;
				.edit {
					color: #3DA1FF;
					cursor: pointer;
				}
			}
			.info_list{
				&>span {
					padding-right: 60px;
					word-break: break-all;
				}
				// display: flex;
				// justify-content: space-between;
			}
			.info_tit {
				font-size: 16px;
				color: #333333;
				font-weight: 600;
			}
			.setting {
				display: flex;
				padding-top: 10px;
				.set_left {
					flex: 1;
					display: flex;
					flex-direction: column;
					line-height: 25px;
				}
				.set_right {
					flex: 1;
					display: flex;
					flex-direction: column;
					line-height: 25px;
				}
				.set_lable {
					color: #999999;
				}
			}
      .other {
        padding-top: 10px;
        line-height: 25px;
        .other_lable {
          color: #999999;
        }
      }
		}
	}
}
</style>
